import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config/config";
import { brandLogoMap } from "../../assets/dummyData";

export const fetchHomepageBrandsShowcase = createAsyncThunk(
  "brandsShowcase/fetchHomepageBrandsShowcase",
  async (_, { rejectWithValue }) => {
    try {
      const brandNames = brandLogoMap.map(b => b.name);
      
      const response = await axios.post(
        `${config.backendUrl}/inventory/homepage_brands_showcase`,
        { brands: brandNames }
      );
      
      return response.data?.results || { new_arrivals: {}, on_sale: {} };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch homepage brands showcase"
      );
    }
  }
);

const initialState = {
  newArrivals: {},
  onSale: {},
  loading: false,
  error: null,
};

const brandsShowcaseSlice = createSlice({
  name: "brandsShowcase",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHomepageBrandsShowcase.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHomepageBrandsShowcase.fulfilled, (state, action) => {
        state.loading = false;
        state.newArrivals = action.payload.new_arrivals || {};
        state.onSale = action.payload.on_sale || {};
      })
      .addCase(fetchHomepageBrandsShowcase.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default brandsShowcaseSlice.reducer;
